import React from 'react'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'

function TimeAgo({ className, dateTime }) {
  const duration = DateTime.fromISO(dateTime).diffNow()
  const timeAgo = ['hours', 'days', 'months', 'years'].reduce((memo, unit) => {
    const amount = Math.floor(duration.as(unit) * -1)
    const time = amount === 1 ? unit.substring(0, unit.length - 1) : unit
    return amount >= 1 ? `${amount} ${time} ago` : memo
  }, 'just now')

  return (
    <time className={className} dateTime={dateTime}>
      {timeAgo}
    </time>
  )
}

TimeAgo.propTypes = {
  className: PropTypes.string,
  dateTime: PropTypes.string.isRequired,
}

TimeAgo.defaultProps = {
  className: null,
}

export default TimeAgo
